"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.load = exports.save = void 0;
var imports_1 = require("@lib/imports");
var voyageMessageCrewCarry_1 = require("@voyage/multi/voyageMessageCrewCarry");
var voyageMessageCrewCarry_sidecar_1 = require("@voyage/multi/voyageMessageCrewCarry-sidecar");
var voyageCarryable_sidecar_1 = require("@voyage/entities/voyageCarryable-sidecar");
var namespace = 'voyage-saver-equipment';
var save = function () {
    var d = {
        items: [],
    };
    imports_1.l.forEach(voyageCarryable_sidecar_1.voyageCarryable.getAll(), function (c) {
        var it = {
            type: c.type,
            loadedId: c.id,
            i: 0,
            j: 0,
            crewId: 0,
        };
        if (c.crew) {
            it.crewId = c.crew.id;
        }
        if (c.tile) {
            it.i = c.tile.i;
            it.j = c.tile.j;
        }
        d.items.push(it);
    });
    return d;
};
exports.save = save;
var load = function (d) {
    try {
        imports_1.l.forEach(d.items, function (c) {
            voyageMessageCrewCarry_sidecar_1.voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
                command: voyageMessageCrewCarry_1.EVoyageCrewCarryCommand.Create,
                carryId1: c.loadedId,
                carryId2: 0,
                crewId: c.crewId,
                i: c.i,
                j: c.j,
                type: c.type,
            });
        });
    }
    catch (err) {
        console.log(namespace, 'load failed', err);
    }
};
exports.load = load;
